






























































































































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';
import AddDefaultCc from './components/add-default-cc.vue';
import EditSave from './components/edit-save.vue';
import * as api from '@/api';
import { State } from 'vuex-class';
import { TenantList } from '@/config/map.conf';
import { cloneDeep, parseInt } from 'lodash';
import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/helpers';
import eventBus from '@/utils/event-bus';
const defaultOption = [
    {
        orgId: 0,
        orgPath: '可从大象个人名片中查找完整部门链，部门链至少三级(如：美团/基础研发平台/研发质量及效率部)',
        disabled: true,
        orgName: ''
    }
];
/**
 * rg模板列表
 *
 * @author liyuyao
 * @date 07/22/2019
 */
@Component({
    components: {
        AddDefaultCc,
        EditSave,
        Container,
        Draggable
    }
})
export default class RgSetting extends Vue {
    @Prop({ default: 'PENDING_REASON' })
    type: string;
    @Prop({ default: false })
    isReply: boolean;

    showCustomStatus: boolean;
    relayContentList: CommonTypes.replyItem[] = [];

    @State(state => state.cti.permission.rg_setting)
    permission: boolean;

    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;

    @Watch('permissionForm.authOrgInfoList')
    authOrgInfoListHandler(val) {
        this.orgDetailList = val;
    }
    activeName: string = 'ticket_setting';
    SETTING_ENUMS = {
        name: '标题',
        desc: '描述',
        createOnes: '转Ones',
        createItsm: '转千寻',
        createChatRoom: '创建大象群',
        circulation: '流转',
        createCase: '转Case',
        sla: '工单等级',
        cloneTicket: '克隆TT',
        ticketType: '类型'
    };

    detailAuthColumnData: any = [
        {
            prop: 'module',
            label: ''
        },
        {
            prop: 'all',
            label: '全员可操作'
        },
        {
            prop: 'rg_and_cc',
            label: '仅RG成员+抄送人可操作'
        },
        {
            prop: 'rg',
            label: '仅RG成员可操作'
        },
        {
            prop: 'none',
            label: '任何人不可操作'
        }
    ];

    detailAuthData: any = [
        {
            module: '标题',
            value: 'name',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '描述',
            value: 'desc',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '工单等级',
            value: 'sla',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '创建大象群',
            value: 'createChatRoom',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '流转',
            value: 'circulation',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '转Ones',
            value: 'createOnes',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '转Case',
            value: 'createCase',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '克隆TT',
            value: 'cloneTicket',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '类型',
            value: 'ticketType',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '重新打开',
            value: 'reopen',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '关闭TT',
            value: 'closeTicket',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '处理完成',
            value: 'doneTicket',
            all: true,
            rg_and_cc: false,
            rg: false,
            none: false
        },
        {
            module: '修改解决方案',
            value: 'resolution',
            all: false,
            rg_and_cc: false,
            rg: false,
            none: true
        },
        {
            module: '修改关闭原因',
            value: 'closedReason',
            all: false,
            rg_and_cc: false,
            rg: false,
            none: true
        }
    ];
    formCustom: any = {
        defaultCc: false,
        defaultCcList: [],
        defaultPrivate: false,
        defaultAdminOnly: false,
        mailSwitch: false,
        mailAddress: '',
        mailItemId: 0,
        reopenAssignToOnCallSwitch: false,
        keepAssignedIfInRgTransfer: false,
        defaultCustomStatusSwitch: false,
        pendingTimeSwitch: false,
        pendingReasons: [],
        defaultSiteCodeSwitch: false,
        needLockIfAssignedChange: false
    };
    permissionForm: any = {
        authActive: true,
        authOrgIds: [],
        authOrgInfoList: [],
        transferAuthActive: true,
        transferOrgIds: [],
        transferAuthOrgInfoList: []
    };
    oldPermissionForm: any = {};
    originInfo: any = {};
    originAgent: any = {};
    originDetailAuth: any = JSON.parse(JSON.stringify(this.detailAuthData));

    addDefaultVisible: boolean = false;
    showDetailEditor: boolean = true;
    originCcList: any = [];

    agentUsersMap: CommonTypes.mapObject = [];
    tenantList: string[] = TenantList;

    editable: boolean = false;
    insideEditable: boolean = false;
    transferEditable: boolean = false;
    detailAuthEditable: boolean = false;
    searchLoading: boolean = false;
    orgDetailList: any = defaultOption;
    $refs: { formCustom: Form };

    rules = {
        mailAddress: [
            {
                validator: (_rule, value, cb) => {
                    const reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
                    if (!value) {
                        // FIXME: 触发 callback(literal) 报错
                        // see: https://github.com/mysticatea/eslint-plugin-node/blob/master/docs/rules/no-callback-literal.md
                        return cb(new Error('请输入邮箱地址'));
                    } else if (!reg.test(value)) {
                        return cb(new Error('请输入合法的邮箱地址'));
                    } else {
                        return cb();
                    }
                },
                trigger: 'blur, hange'
            }
        ],
        mailItemId: [
            {
                validator: (_rule, value, cb) => {
                    if (!value) {
                        return cb(new Error('请输入三级目录id'));
                    } else if (isNaN(value)) {
                        return cb(new Error('请输入合法的三级目录id'));
                    } else {
                        return cb();
                    }
                },
                trigger: 'blur, change'
            }
        ]
    };
    mounted() {
        this.getDefaultSetting();
        this.getTenantAgent();
        this.getPermissionSetting();
        this.getRgReplyField();
    }

    get limitText() {
        return this.isReply ? 500 : 10;
    }

    get apiName() {
        return this.isReply ? 'Text' : 'Field';
    }

    async getRgReplyField() {
        const res = await api.rgApi[`getRgReply${this.apiName}`]({
            type: 'CUSTOM_STATUS',
            rgId: this.rgId
        });
        this.relayContentList = res.data.items;
    }

    onDropEvent(dropResult) {
        this.relayContentList = applyDrag(this.relayContentList, dropResult);
        const ids = this.relayContentList.map(item => item.id);
        this.sortContent(ids);
    }

    async sortContent(ids) {
        const res = await api.rgApi.sortFields({
            orderIds: ids,
            rgId: this.rgId,
            type: 'CUSTOM_STATUS'
        });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message('操作成功！');
            this.getRgReplyField();
        }
    }

    deleteContent(replyItem) {
        const { id } = replyItem;
        // if (!this.isReply && this.relayContentList.length <= 1) {
        //     this.$mtd.message.error('至少要保留一个字段');
        //     return;
        // }
        this.$mtd
            .confirm({
                title: '删除选项',
                showCancelButton: true,
                type: 'error',
                message: `确定要删除选项“${replyItem.content}”吗？`,
                onOk: async () => {
                    const res = await api.rgApi[`deleteReply${this.apiName}`](id, {
                        rgId: this.rgId
                    });
                    const { code } = res;
                    if (code === 200) {
                        this.relayContentList = this.relayContentList.filter(item => item.id !== id); // 手动移除删除的项
                        this.getRgReplyField();
                        this.$mtd.message.success('操作成功');
                    }
                }
            })
            .catch(e => e);
    }

    addReplyItem() {
        this.$mtd
            .confirm({
                title: '添加选项',
                message: this.isReply ? '<textarea id="reply-edit-item" class="mtd-textarea" />' : '<input id="reply-edit-item" class="mtd-input" />',
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                onOk: async () => {
                    const content = (document.getElementById('reply-edit-item') as HTMLInputElement).value;
                    if (content.length && content.length <= this.limitText) {
                        const res = await api.rgApi[`addReply${this.apiName}`]({
                            content: content,
                            rgId: this.rgId,
                            type: 'CUSTOM_STATUS'
                        });
                        const { code } = res;
                        if (code === 200) {
                            this.$mtd.message.success('操作成功');
                            this.getRgReplyField();
                        }
                    } else {
                        this.$mtd.message.error(`选项内容限${this.limitText}字`);
                    }
                }
            })
            .catch(e => e);
    }

    editContent(replyItem) {
        const { id } = replyItem;
        this.$mtd
            .confirm({
                title: '编辑选项',
                message: this.isReply
                    ? `<textarea id="reply-edit-item" class="mtd-textarea">${replyItem.content}</textarea>`
                    : `<input id="reply-edit-item" class="mtd-input" value="${replyItem.content}" />`,
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                onOk: async () => {
                    const textareaElement = document.getElementById('reply-edit-item') as HTMLTextAreaElement;
                    const content = textareaElement.value;
                    if (content.length && content.length <= this.limitText) {
                        const res = await api.rgApi[`editReply${this.apiName}`]({
                            id: id,
                            content: content,
                            type: 'CUSTOM_STATUS',
                            rgId: this.rgId
                        });
                        const { code } = res;
                        if (code === 200) {
                            this.getRgReplyField();
                            this.$mtd.message.success('操作成功');
                        }
                    } else {
                        this.$mtd.message.error(`选项内容限${this.limitText}字`);
                    }
                }
            })
            .catch(e => e);
    }

    addDialog() {
        this.addDefaultVisible = true;
    }
    cancel(param: string) {
        if (param === 'inside') {
            this.permissionForm.authOrgInfoList = this.oldPermissionForm.authOrgInfoList;
            this.permissionForm.authActive = this.oldPermissionForm.authActive;
            this.insideEditable = false;
        } else if (param === 'transfer') {
            this.permissionForm.transferAuthOrgInfoList = this.oldPermissionForm.transferAuthOrgInfoList;
            this.permissionForm.transferAuthActive = this.oldPermissionForm.transferAuthActive;
            this.transferEditable = false;
        }
    }
    save(param: string) {
        this.editPermissionSetting(param);
        if (param === 'inside') {
            this.insideEditable = false;
        } else if (param === 'transfer') {
            this.transferEditable = false;
        }
    }
    async getDefaultSetting() {
        const res = await api.rgApi.getRgSetting(this.rgId);
        const detailRes = await api.rgApi.getDetailEditAuth(this.rgId);

        const { code, data } = res;

        if (code === 200) {
            this.originInfo = data;
            this.formCustom.defaultCcList = this.formatToArr(data.userMap);
            this.formCustom.defaultPrivate = data.auth === 'private';
            this.formCustom.defaultCc = data.ccSwitch === 'on';
            this.formCustom.mailSwitch = data.mailSwitch === 'on';
            this.formCustom.reopenAssignToOnCallSwitch = data.reopenAssignToOnCallSwitch === 'on';
            this.formCustom.mailAddress = data.mailAddress || '';
            this.formCustom.mailItemId = data.mailItemId || 0;
            this.formCustom.defaultAdminOnly = !!data.adminOnly;
            this.formCustom.keepAssignedIfInRgTransfer = !!data.keepAssignedIfInRgTransfer;
            this.showCustomStatus = data.customStatusSwitch !== 'null';
            this.formCustom.pendingTimeSwitch = data.pendingTimeSwitch || false;
            this.formCustom.pendingReasons = data.pendingReasons || [];
            this.formCustom.defaultSiteCodeSwitch = data.siteCodeSwitch === 'on';
            this.formCustom.needLockIfAssignedChange = !!data.needLockIfAssignedChange;
            if (this.showCustomStatus) {
                this.formCustom.defaultCustomStatusSwitch = data.customStatusSwitch === 'on';
            }
        }

        const { code: detailCode, data: { settingMap } = {} } = detailRes;
        if (detailCode === 200 && settingMap) {
            const newData = this.detailAuthData.map(data => {
                const authKey = (settingMap[data.value] || 'ALL').toLowerCase();
                data[authKey] = true;
                ['all', 'rg_and_cc', 'rg', 'none'].filter(item => authKey !== item).forEach(item => (data[item] = false));
                return data;
            });
            this.detailAuthData = newData;
            this.originDetailAuth = JSON.parse(JSON.stringify(newData));
        }
        // 如果是超级管理员，则不判断管理员，否则会 toast 无权限
        if (this.userInfo.sysAdmin) {
            this.showDetailEditor = true;
            return;
        }
        const rgRole = await api.rgApi.getRgRole(this.rgId);
        const { code: rgCode, data: { role } = {} } = rgRole;
        if (rgCode === 200 && role === 'RGADMIN') {
            this.showDetailEditor = true;
        }
    }
    formatToArr(obj) {
        const result = [];
        for (const key in obj) {
            result.push({
                username: key,
                displayName: obj[key]
            });
        }
        return result;
    }
    removeTag(index) {
        this.formCustom.defaultCcList.splice(index, 1);
        this.submitSettingChange({
            users: this.formCustom.defaultCcList.map(user => {
                return user.username;
            })
        });
    }
    pendingTimeSwitchChange(val) {
        this.submitSettingChange({ pendingTimeSwitch: val });
    }
    ccSwitchChange(val) {
        this.submitSettingChange({ ccSwitch: val ? 'on' : 'off' });
    }
    authSwitchChange(auth) {
        this.submitSettingChange({ auth: auth ? 'private' : 'public' });
    }
    adminSwitchChange(val) {
        this.submitSettingChange({ adminOnly: val });
    }
    mailSwitchChange(val) {
        if (!val) {
            this.submitSettingChange({ mailSwitch: 'off' });
        } else {
            this.submitMailInfo();
        }
    }
    stateSwitchChange(val) {
        this.submitSettingChange({ customStatusSwitch: val ? 'on' : 'off' });
    }
    submitMailInfo() {
        this.$refs.formCustom
            .validate(valid => {
                if (
                    valid &&
                    this.formCustom.mailAddress &&
                    this.formCustom.mailItemId &&
                    (this.formCustom.mailAddress !== this.originInfo.mailAddress ||
                        this.formCustom.mailSwitch !== (this.originInfo.mailSwitch === 'on') ||
                        this.formCustom.mailItemId !== this.originInfo.mailItemId)
                ) {
                    this.submitSettingChange({
                        mailSwitch: this.formCustom.mailSwitch ? 'on' : 'off',
                        mailAddress: this.formCustom.mailAddress,
                        mailItemId: this.formCustom.mailItemId
                    });
                }
            })
            .catch(e => e);
    }
    reopenSwitchChange(val) {
        this.submitSettingChange({ reopenAssignToOnCallSwitch: val ? 'on' : 'off' });
    }
    siteCodeChange(val) {
        this.submitSettingChange({ siteCodeSwitch: val ? 'on' : 'off' });
    }

    lockSwitchChange(val) {
        this.submitSettingChange({ needLockIfAssignedChange: !!val });
    }

    async submitSettingChange(params) {
        params.rgId = this.rgId;
        try {
            const res = await api.rgApi.sendRgSetting(params);
            const { code, data } = res;
            if (code === 200) {
                this.$mtd.message.success('修改成功');
                this.originInfo = data;
                if (this.originInfo.pendingReasons) {
                    this.formCustom.pendingReasons = this.originInfo.pendingReasons;
                }
            }
        } catch (e) {
            this.$mtd.message.error(`修改失败，原因：${e}`);
        }
    }
    async getTenantAgent() {
        const res = await api.rgApi.getTenantAgent(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            this.agentUsersMap = TenantList.map((tenant: string) => {
                return {
                    tenant: tenant,
                    list: data.items.filter(account => {
                        return account.tenantType === tenant;
                    })
                };
            });
            this.originAgent = JSON.parse(JSON.stringify(this.agentUsersMap));
        }
    }
    agentSave() {
        this.$mtd
            .confirm({
                title: '注意',
                message: '确定要授权该服务组对应的所有服务目录对该类账号可见吗？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: async () => {
                    const params = this.formatAgentParams();
                    const res = await api.rgApi.tenantModify(params);
                    const { code } = res;
                    if (code === 200) {
                        this.$mtd.message.success('修改成功');
                    }
                    this.editable = false;
                }
            })
            .catch(e => e);
    }
    detailAuthchanged(index, authProp) {
        const oldData = this.detailAuthData;
        oldData[index][authProp] = true;
        ['all', 'rg_and_cc', 'rg', 'none'].filter(item => authProp !== item).forEach(item => (oldData[index][item] = false));
        this.detailAuthData = oldData;
    }
    async detailAuthSave() {
        const newData = this.detailAuthData;
        const oldData = this.originDetailAuth;
        const changeData = newData
            .map((item, index) => {
                let value = 'all';
                const hasChanged = ['all', 'rg_and_cc', 'rg', 'none']
                    .filter(key => item[key])
                    .some(key => {
                        value = key;
                        return !oldData[index][key];
                    });
                return hasChanged
                    ? {
                          rgId: this.rgId,
                          type: newData[index].value,
                          value: value.toUpperCase()
                      }
                    : false;
            })
            .filter(Boolean);
        Promise.all(changeData.map(api.rgApi.sendDetailEditAuth))
            .then(resultArray => {
                const isOK = resultArray.every((res: any) => res.code === 200);
                if (isOK) {
                    this.$mtd.message.success('修改成功');
                } else {
                    this.$mtd.message.error('修改失败');
                }
                this.detailAuthEditable = false;
                this.originDetailAuth = JSON.parse(JSON.stringify(newData));
            })
            .catch(e => {
                this.$mtd.message.error(`修改失败，原因：${e}`);
                this.detailAuthEditable = false;
            });
    }
    formatAgentParams() {
        let result = [];
        this.agentUsersMap.forEach(agent => {
            const accounts = agent.list.map(account => {
                return {
                    action: account.active ? 'ADD' : 'DELETE',
                    rgId: this.rgId,
                    tenant: account.tenant
                };
            });
            result = result.concat(accounts);
        });
        return result;
    }
    filterActiveAccount(list) {
        const result = [];
        list.forEach(account => {
            if (account.active === true) {
                result.push(account.tenantName);
            }
        });
        return result.length ? result.join('，') : '无';
    }
    agentCancel() {
        this.agentUsersMap = JSON.parse(JSON.stringify(this.originAgent));
    }
    detailAuthCancel() {
        this.detailAuthData = JSON.parse(JSON.stringify(this.originDetailAuth));
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    formatter(val) {
        if (val.value) {
            return `${val.value.orgName}`;
        }
    }
    async searchOrg(query) {
        if (query.length < 1) {
            this.orgDetailList = defaultOption;
            return;
        }
        this.searchLoading = true;
        try {
            const res = await api.ctiApi.orgDetailByPath(encodeURIComponent(query));
            const { data } = res;
            if (data) {
                this.orgDetailList = [data];
            } else {
                this.orgDetailList = [];
            }
        } catch (e) {
            console.log(e);
        }
        this.searchLoading = false;
    }
    async getPermissionSetting() {
        try {
            const res = await api.rgApi.getRgCtiPermission(this.rgId);
            const { code, data } = res;
            if (code === 200) {
                this.permissionForm = { ...data };
                this.oldPermissionForm = cloneDeep(this.permissionForm);
            }
        } catch (e) {
            console.log(e);
        }
    }
    async editPermissionSetting(param: string) {
        let requestParam: any = {};
        if (param === 'inside') {
            if (this.permissionForm.authActive) {
                if (this.permissionForm.authOrgInfoList.length > 0) {
                    this.permissionForm.authOrgIds = this.permissionForm.authOrgInfoList.map(item => {
                        return item.orgId;
                    });
                } else {
                    this.permissionForm.authActive = false;
                }
            } else {
                this.permissionForm.authOrgInfoList = [];
            }
            requestParam = {
                rgId: this.rgId,
                authActive: this.permissionForm.authActive,
                authOrgInfoList: this.permissionForm.authOrgInfoList
            };
        } else if (param === 'transfer') {
            if (this.permissionForm.transferAuthActive) {
                if (this.permissionForm.transferAuthOrgInfoList.length > 0) {
                    this.permissionForm.authOrgIds = this.permissionForm.transferAuthOrgInfoList.map(item => {
                        return item.orgId;
                    });
                } else {
                    this.permissionForm.transferAuthActive = false;
                }
            } else {
                this.permissionForm.transferAuthOrgInfoList = [];
            }
            requestParam = {
                rgId: this.rgId,
                transferAuthActive: this.permissionForm.transferAuthActive,
                transferAuthOrgInfoList: this.permissionForm.transferAuthOrgInfoList
            };
        }
        try {
            const res = await api.rgApi.editRgCtiPermission(this.rgId, requestParam);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success('保存成功');
            }
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * 点击配置跳转到常用回复页
     * 通过eventBus改变tab的active
     */
    navToReplyFiled() {
        this.$router
            .push({
                name: 'rg_reply',
                query: {
                    rgId: this.rgId
                }
            })
            .then(() => {
                eventBus.$emit('changeTabActive', 'rg_reply');
            })
            .catch(e => e);
    }
}
